<i18n>
{
  "fr": {
    "title": "Ajouter des bagages en option",
    "no-options-for-outward": "Pas d'options disponibles pour l'aller",
    "no-options-for-return": "Pas d'options disponibles pour le retour"
  },
  "en": {
    "title": "Add luggage option",
    "no-options-for-outward": "No options available for the outward journey",
    "no-options-for-return": "No options available for the return journey"
  }
}
</i18n>

<template>
  <v-card flat>
    <v-card-title>
      <h1 class="title">
        {{ $t('title') }}
      </h1>
    </v-card-title>

    <v-card-text>
      <v-row
        v-if="areLuggageOptionsCommon"
        class="flex-wrap"
      >
        <div class="align-self-center ml-12">
          <SelectLuggageOption
            :options-param="selectedOptionsParams.LuggageOptions"
            type-of-flight="common"
            @input="selectedOptionsParams.LuggageOptions = $event"
          />
        </div>
        <TotalLuggageSentence
          :options-params="selectedOptionsParams"
          option-key="LuggageOptions"
          class="align-self-center ml-12"
        />
      </v-row>
      <v-row
        v-if="(areLuggageOptionsOutward || areLuggageOptionsReturn) && !areLuggageOptionsCommon"
      >
        <v-col
          v-if="areLuggageOptionsOutward"
          cols="12"
        >
          <v-row class="flex-wrap">
            <div class="align-self-center ml-12">
              <SelectLuggageOption
                :options-param="selectedOptionsParams.OutwardLuggageOptions"
                type-of-flight="outward"
                @input="selectedOptionsParams.OutwardLuggageOptions = $event"
              />
            </div>
            <TotalLuggageSentence
              :options-params="selectedOptionsParams"
              option-key="OutwardLuggageOptions"
              class="align-self-center ml-12"
            />
          </v-row>
        </v-col>
        <v-col
          v-if="areLuggageOptionsReturn"
          cols="12"
        >
          <v-row class="flex-wrap">
            <div class="align-self-center ml-12">
              <SelectLuggageOption
                :options-param="selectedOptionsParams.ReturnLuggageOptions"
                type-of-flight="return"
                @input="selectedOptionsParams.ReturnLuggageOptions = $event"
              />
            </div>
            <TotalLuggageSentence
              :options-params="selectedOptionsParams"
              option-key="ReturnLuggageOptions"
              class="align-self-center ml-12"
            />
          </v-row>
        </v-col>
        <i
          v-if="!areLuggageOptionsOutward"
          class="ml-12 caption grey--text text--lighten-1"
        >{{ $t('no-options-for-outward') }}</i>
        <i
          v-if="!areLuggageOptionsReturn"
          class="ml-12 caption grey--text text--lighten-1"
        >{{ $t('no-options-for-return') }}</i>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import SelectLuggageOption
  from '@/components/Flight/FlightPassengersInformation/FlightLuggageOptions/SelectLuggageOption/SelectLuggageOption'
import { mapMutations } from 'vuex'
import _ from 'lodash'
import TotalLuggageSentence
  from '@/components/Flight/FlightPassengersInformation/FlightLuggageOptions/TotalLuggageSentence/TotalLuggageSentence'

export default {
  name: 'FlightLuggageOptions',
  components: { TotalLuggageSentence, SelectLuggageOption },
  props: {
    optionsParams: {
      type: Object,
      required: true
    },
    areLuggageOptionsOutward: {
      type: Boolean
    },
    areLuggageOptionsReturn: {
      type: Boolean
    },
    areLuggageOptionsCommon: {
      type: Boolean
    }
  },
  data: () => ({
    selectedOptionsParams: {}
  }),
  watch: {
    selectedOptionsParams: {
      handler: function (newVal) {
        this.changeSelectedLuggageOptions(_.cloneDeep(newVal))
      },
      deep: true
    }
  },
  created () {
    this.selectedOptionsParams = _.cloneDeep(this.optionsParams)
  },
  methods: {
    ...mapMutations({
      changeSelectedLuggageOptions: 'fb/passengersInformation/changeCommonSelectedLuggageOption'
    })
  }
}
</script>

<style scoped>
</style>
